import Swal from "sweetalert2";
import * as Type from "store/actionTypes/customer";
import {
  getCustomers,
  createCustomer as createCustomerService,
  updateCustomer as updateCustomerService,
  deleteCustomer as deleteCustomerService,
} from "services";

export const getCustomer =
  (params = "") =>
  async (dispatch) => {
    try {
      dispatch({
        type: Type.CUSTOMER_REQUEST,
      });
      const res = await getCustomers(params);
      dispatch({
        type: Type.GET_CUSTOMER_SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      Swal.fire("error", err.message, "error");
      dispatch({
        type: Type.GET_CUSTOMER_ERROR,
        payload: err.message,
      });
    }
  };

export const createCustomer = (data) => async (dispatch) => {
  try {
    dispatch({
      type: Type.CUSTOMER_REQUEST,
    });
    const res = await createCustomerService(data);
    // Swal.fire('success', res.message, 'success')
    dispatch({
      type: Type.CREATE_CUSTOMER_SUCCESS,
      payload: res.message,
    });
  } catch (err) {
    Swal.fire("error", err.message, "error");
    dispatch({
      type: Type.CREATE_CUSTOMER_ERROR,
      payload: err.message,
    });
  }
};

export const updateCustomer = (data, id) => async (dispatch) => {
  try {
    dispatch({
      type: Type.CUSTOMER_REQUEST,
    });
    const res = await updateCustomerService(data, id);
    // Swal.fire('success', res.message, 'success')
    dispatch({
      type: Type.UPDATE_CUSTOMER_SUCCESS,
      payload: res.message,
    });
  } catch (err) {
    Swal.fire("error", err.message, "error");
    dispatch({
      type: Type.UPDATE_CUSTOMER_ERROR,
      payload: err.message,
    });
  }
};

export const deleteCustomer = (id) => async (dispatch) => {
  try {
    dispatch({
      type: Type.CUSTOMER_REQUEST,
    });
    const res = await deleteCustomerService(id);
    Swal.fire("success", res.message, "success");
    dispatch({
      type: Type.DELETE_CUSTOMER_SUCCESS,
      payload: res.message,
    });
  } catch (err) {
    Swal.fire("error", err.message, "error");
    dispatch({
      type: Type.DELETE_CUSTOMER_ERROR,
      payload: err.message,
    });
  }
};
